import { jwtDecode } from "jwt-decode"; // Install with `npm install jwt-decode`

export const isLoggedIn = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    return false;
  }

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000; // Current time in seconds
    if (decoded.exp < currentTime) {
      // Token is expired
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return false;
    }
    return true; // Token is valid
  } catch (error) {
    console.error("Invalid token:", error);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return false;
  }
};
